import classnames from "~utils/classnames/classnames";

import Icon from "~components/Icon";

import {
  NotificationProps,
  NotificationVariant,
  NotificationVariantStyle,
} from "./types";

const variantStyles: Record<NotificationVariant, NotificationVariantStyle> = {
  info: {
    bgColor: "bg-info-light",
    textColor: "text-matte-black",
    iconType: "info",
  },
  warning: {
    bgColor: "bg-warning-light",
    textColor: "text-matte-black",
    iconType: "info",
  },
  error: {
    bgColor: "bg-error-light",
    textColor: "text-error",
    iconType: "info",
  },
  success: {
    bgColor: "bg-success-light",
    textColor: "text-matte-black",
    iconType: "info",
  },
};

const Notification: React.FC<NotificationProps> = ({
  variant = "error",
  icon,
  children,
  className = "",
}) => {
  const variantStyle = variantStyles[variant];
  const iconToUse = icon || variantStyle.iconType;

  return (
    <div
      className={classnames(
        "text-body flex items-start gap-2 rounded-md p-4",
        variantStyle.bgColor,
        variantStyle.textColor,
        className,
      )}
    >
      <div className="m-0.5 flex shrink-0">
        <Icon type={iconToUse} size={1.2} />
      </div>
      {children}
    </div>
  );
};

export default Notification;
